import { render, staticRenderFns } from "./config_main.vue?vue&type=template&id=4ed07738&"
import script from "./config_main.vue?vue&type=script&lang=js&"
export * from "./config_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports